var exports = {
  "xQ": "footerContainer__O-rENG",
  "NC": "buttonsContainer__5FFhL3",
  "VD": "errorMessageText__KRucOV",
  "YQ": "FooterActionsSpinner__cYxNz2",
  "F$": "applyButton__MYphj4",
};

module.exports = exports;
